import { IEmitEventModal, IModalConfig } from './../interfaces'
import { useDispatch, useSelector } from 'react-redux'
import {
  closeModalAction,
  commonSelector,
  openModalAction,
  setEnableSendModal,
  setLoadingModal,
  setValidationDataModal
} from 'store/commonSlice'

const modalData = {
  component: (<></>) as React.ReactNode,
  actionWhenClose: (data?: any) => {},
  modalSetting: {} as IModalConfig
}

const useModal = () => {
  const dispatch = useDispatch()
  const { open: isOpen } = useSelector(commonSelector).modal

  const open = (
    component: React.ReactNode,
    modalSetting: IModalConfig = {},
    actionWhenClose: (data?: any) => void = () => {}
  ) => {
    modalData.component = component
    modalData.actionWhenClose = actionWhenClose
    modalData.modalSetting = modalSetting
    setTimeout(() => {
      dispatch(openModalAction({ isOpen: true, component: component }))
    })
  }

  const close = (data?: any) => {
    dispatch(closeModalAction())
    if (!isOpen) {
      return
    }
    modalData.actionWhenClose(data)
    if (modalData.modalSetting?.emitEvent) {
      return
    }
    dispatch(closeModalAction())
  }

  const forceClose = () => {
    dispatch(closeModalAction())
  }

  const setInvalid = (invalid: boolean) => {
    dispatch(setValidationDataModal(invalid))
  }

  const setLoading = (loading: boolean) => {
    dispatch(setLoadingModal(loading))
  }

  const setEnableSend = (loading: string) => {
    dispatch(setEnableSendModal(loading))
  }

  const emitEvent = (event: IEmitEventModal) => {
    modalData.modalSetting.emitEvent = event
    modalData.actionWhenClose(event)
  }

  const updateEnableSendAction = (value: string) => {
    setEnableSend(value)
  }

  return {
    open,
    close,
    forceClose,
    setInvalid,
    setLoading,
    isOpen,
    component: modalData.component,
    emitEvent,
    actionWhenClose: modalData.actionWhenClose,
    modalSetting: modalData.modalSetting,
    onSendAction: modalData.actionWhenClose,
    updateEnableSendAction
  }
}

export default useModal
